export const Loader: React.FC = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.054 16.7395C0.89123 14.9082 1.09076 13.0627 1.64118 11.3086C2.19161 9.5544 3.08216 7.92581 4.26198 6.5158C5.4418 5.10579 6.88779 3.94197 8.51739 3.09079C10.147 2.23961 11.9283 1.71774 13.7596 1.55497C15.5909 1.39221 17.4363 1.59173 19.1905 2.14216C20.9446 2.69258 22.5732 3.58313 23.9832 4.76295C25.3932 5.94278 26.5571 7.38877 27.4082 9.01837C28.2594 10.648 28.7813 12.4293 28.944 14.2606"
        stroke="#9797A0"
        strokeWidth="2"
      />
      <path
        d="M4.02005 24.1838C2.8411 22.6929 1.97808 20.9776 1.48358 19.1423"
        stroke="#9797A0"
        strokeWidth="2"
      />
      <path
        d="M9.83318 28.5111C8.06674 27.8094 6.46167 26.7554 5.1158 25.4133"
        stroke="#9797A0"
        strokeWidth="2"
      />
    </svg>
  );
};
